import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';

Vue.use(Vuex);

export default {
    namespaced: true,
    state: {
        comparatives: {}
    },
    actions: {
        async getComparatives({commit}) {
            let {data} = await axios.get('/client/comparatives/active');
            commit('setComparatives', data);
        }
    },
    mutations : {
        setComparatives(state, data) {
            state.comparatives = data;
        }
    }
}